// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home.css */

.home-content {
  position: relative;
  z-index: 1;
}

/* Card Header */
.card-header {
  background-color: var(--ion-card-header-background);
}

/* PDF Viewers */
.pdf-viewers {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.pdf-viewer {
  flex: 1 1 48%;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .pdf-viewer {
    flex: 1 1 100%;
  }
}

/* Progress Bar Container */
.progress-bar-container {
  padding: 20px 0;
  text-align: center;
}

.progress-bar-container h2 {
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.progress-percentage {
  margin-top: 10px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

/* Refresh Button Container */
.refresh-button-container {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}

/* Card Container */
.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.card-container .ion-col {
  width: 100%;
  max-width: 450px;
  min-width: 300px;
  margin-bottom: 20px;
}

.card-container .ion-col:last-child {
  margin-bottom: 0;
}

/* Submit Button Container */
.submit-button-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  padding: 10px 0;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.submit-button-container ion-button {
  width: 90%;
  margin: 0 auto;
}

/* Custom Modal Content */
.custom-modal-content {
  padding: 20px;
}

.custom-modal .ion-header {
  --background: var(--ion-color-primary);
  color: white;
}

.custom-modal iframe {
  border: none;
  width: 100%;
  height: 100%;
}

/* Adjustments for Mobile */
@media (max-width: 768px) {
  .progress-percentage {
    font-size: 18px;
  }

  .progress-bar-container {
    padding: 10px 0;
  }

  .refresh-button-container {
    padding: 0 10px;
  }

  .card-container {
    padding: 0 10px;
  }

  .card-container .ion-col {
    width: 100%;
    min-width: 320px;
  }
}
.footer-logo {
  max-height: 40px; /* Size the logo appropriately for the footer */
  width: auto;
  object-fit: contain;
  margin: 10px 0;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/NewHireHome.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,mDAAmD;AACrD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB,EAAE,+CAA+C;EACjE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* Home.css */\n\n.home-content {\n  position: relative;\n  z-index: 1;\n}\n\n/* Card Header */\n.card-header {\n  background-color: var(--ion-card-header-background);\n}\n\n/* PDF Viewers */\n.pdf-viewers {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.pdf-viewer {\n  flex: 1 1 48%;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .pdf-viewer {\n    flex: 1 1 100%;\n  }\n}\n\n/* Progress Bar Container */\n.progress-bar-container {\n  padding: 20px 0;\n  text-align: center;\n}\n\n.progress-bar-container h2 {\n  margin-bottom: 10px;\n  font-size: 1.5rem;\n}\n\n.progress-percentage {\n  margin-top: 10px;\n  font-size: 20px;\n  font-weight: bold;\n  text-align: center;\n}\n\n/* Refresh Button Container */\n.refresh-button-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n/* Card Container */\n.card-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.card-container .ion-col {\n  width: 100%;\n  max-width: 450px;\n  min-width: 300px;\n  margin-bottom: 20px;\n}\n\n.card-container .ion-col:last-child {\n  margin-bottom: 0;\n}\n\n/* Submit Button Container */\n.submit-button-container {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  padding: 10px 0;\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n.submit-button-container ion-button {\n  width: 90%;\n  margin: 0 auto;\n}\n\n/* Custom Modal Content */\n.custom-modal-content {\n  padding: 20px;\n}\n\n.custom-modal .ion-header {\n  --background: var(--ion-color-primary);\n  color: white;\n}\n\n.custom-modal iframe {\n  border: none;\n  width: 100%;\n  height: 100%;\n}\n\n/* Adjustments for Mobile */\n@media (max-width: 768px) {\n  .progress-percentage {\n    font-size: 18px;\n  }\n\n  .progress-bar-container {\n    padding: 10px 0;\n  }\n\n  .refresh-button-container {\n    padding: 0 10px;\n  }\n\n  .card-container {\n    padding: 0 10px;\n  }\n\n  .card-container .ion-col {\n    width: 100%;\n    min-width: 320px;\n  }\n}\n.footer-logo {\n  max-height: 40px; /* Size the logo appropriately for the footer */\n  width: auto;\n  object-fit: contain;\n  margin: 10px 0;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
